import { Spin } from 'antd';
import MaterialIcon from 'material-icons-react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import styles from './search.css';
import { doSearch } from './searchActions';
import queryString from 'query-string';

class SearchResultComponent extends Component {

  componentDidMount() {
    this.props.dispatch(doSearch(this.props.query));
  }

  componentDidUpdate(prevProps){

    if(prevProps.query !== this.props.query){
      this.props.dispatch(doSearch(this.props.query));
    }
  }

  clickSearchResult(sr) {

    let link = sr.link;

    if (link.indexOf('lag/') >= 0) {
      link = `lagdel/${link}`;
    }

    window.open(link, '_blank');
  }

  getIcon(original){
    return (original==='clipboard-text' || original==='compass-outline')? 'book' : original;
  }

  render() {

    return (
      <div>

        {this.props.searchResults.map((sr) => (
          <div style={styles.searchResult} onClick={(e) => this.clickSearchResult(sr)}>
            <div style={styles.searchResultHeader}>
              <MaterialIcon style={{margin:5}} icon={this.getIcon(sr.icon)} size={18} />

              <h3 style={styles.searchResultHeaderH3}> {sr.title}</h3>
            </div>
            <div dangerouslySetInnerHTML={{ __html: sr.text }} />
          </div>
        ))}

        <Spin spinning={this.props.loading}>
        </Spin>

      </div>
    )
  }
}


const mapStateToProps = (state, ownProps) => {

  const qs = queryString.parse(ownProps.location.search);

  return {
    query: qs.q,
    searchResults: state.search.searchResults,
    hasMoreEntries: state.search.hasMoreEntries,
    loading: state.search.loading
  }
};

export default connect(mapStateToProps)(withRouter(SearchResultComponent));



// WEBPACK FOOTER //
// ./src/search/searchResultComponent.js